__turbopack_context__.v({
  "ant-form-item": "J7qk3a_ant-form-item",
  "ant-select-selector": "J7qk3a_ant-select-selector",
  "buttonSubmit": "J7qk3a_buttonSubmit",
  "custom": "J7qk3a_custom",
  "form": "J7qk3a_form",
  "images": "J7qk3a_images",
  "infoimages": "J7qk3a_infoimages",
  "informasilabel": "J7qk3a_informasilabel",
  "informasilabel1": "J7qk3a_informasilabel1",
  "input": "J7qk3a_input",
  "inputCalendar": "J7qk3a_inputCalendar",
  "inputForm": "J7qk3a_inputForm",
  "question": "J7qk3a_question",
  "title": "J7qk3a_title",
  "titleContent": "J7qk3a_titleContent",
});
